// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"322":"c5fbd26a","582":"53d3bbba"}[chunkId] + ".chunk.js";
};